/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubmissionStatusPayloadDto
 */
export interface UpdateSubmissionStatusPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionStatusPayloadDto
     */
    status: UpdateSubmissionStatusPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionStatusPayloadDto
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionStatusPayloadDto
     */
    competitorRateOnLine?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionStatusPayloadDto
     */
    competitorRateOnExposure?: string;
}


/**
 * @export
 */
export const UpdateSubmissionStatusPayloadDtoStatusEnum = {
    Declined: 'Declined',
    Cancelled: 'Cancelled',
    Pending: 'Pending',
    Quoted: 'Quoted',
    Complete: 'Complete'
} as const;
export type UpdateSubmissionStatusPayloadDtoStatusEnum = typeof UpdateSubmissionStatusPayloadDtoStatusEnum[keyof typeof UpdateSubmissionStatusPayloadDtoStatusEnum];


/**
 * Check if a given object implements the UpdateSubmissionStatusPayloadDto interface.
 */
export function instanceOfUpdateSubmissionStatusPayloadDto(value: object): value is UpdateSubmissionStatusPayloadDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateSubmissionStatusPayloadDtoFromJSON(json: any): UpdateSubmissionStatusPayloadDto {
    return UpdateSubmissionStatusPayloadDtoFromJSONTyped(json, false);
}

export function UpdateSubmissionStatusPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubmissionStatusPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'competitorRateOnLine': json['competitorRateOnLine'] == null ? undefined : json['competitorRateOnLine'],
        'competitorRateOnExposure': json['competitorRateOnExposure'] == null ? undefined : json['competitorRateOnExposure'],
    };
}

export function UpdateSubmissionStatusPayloadDtoToJSON(json: any): UpdateSubmissionStatusPayloadDto {
    return UpdateSubmissionStatusPayloadDtoToJSONTyped(json, false);
}

export function UpdateSubmissionStatusPayloadDtoToJSONTyped(value?: UpdateSubmissionStatusPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reason': value['reason'],
        'competitorRateOnLine': value['competitorRateOnLine'],
        'competitorRateOnExposure': value['competitorRateOnExposure'],
    };
}

